import React, { FC, useState } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { ExpertiseListSvg } from '../../icons';
import { ExpertiseType } from '../../pages/ExpertisePage/types';
import { routerPath } from '../../router/routerPath';
import { BlueLayout, CustomButton, CustomModal, GridItem, TextLink } from '../../styles/styled';

type ExpertiseListModalComponentProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  id?: number;
  isPovs?: boolean;
  expertise_list?: ExpertiseType;
  isExpert?: boolean;
  isRejected?: boolean;
  setLoad?: () => void;
};

export const ExpertiseListModalComponent: FC<ExpertiseListModalComponentProps> = ({
  setOpen,
  open,
  isRejected,
  id,
  expertise_list,
  isExpert,
  isPovs,
  setLoad,
}) => {
  const navigate = useNavigate();
  const [confirmState, setConfirmState] = useState<boolean>(true);
  const [commentState, setComment] = useState<string>('');
  const radioOptions = [
    { label: 'подтвердить', value: 'confirm' },
    { label: 'отправить на доработку', value: 'cancel' },
  ];

  const acceptExpertiseList = () => {
    if (id)
      api.put(endpoints.acceptExpertiseListById(id)).then(() => {
        if (setLoad) setLoad();

        setOpen(false);
      });
  };

  const rejectExpertiseList = () => {
    if (id)
      api.put(endpoints.rejectExpertiseListById(id), { fo_reject_comment: commentState }).then(() => {
        if (setLoad) setLoad();

        setOpen(false);
      });
  };

  return (
    <CustomModal
      title=""
      centered
      footer={null}
      visible={id ? open : false}
      onOk={() => {
        setOpen(false);
      }}
      onCancel={() => setOpen(false)}
      width={550}
    >
      <GridItem direction="column" align="flex-start" padding="40px 10px 10px 10px" gap="30px">
        <GridItem align="center" justify="center">
          <BlueLayout fontsize="24px">Экспертный лист</BlueLayout>
        </GridItem>
        <GridItem direction="row" gap="15px" justify="flex-start" align="center">
          <ExpertiseListSvg />
          <TextLink color="#38485BCC">
            <GridItem align="center" justify="flex-start" gap="10px" direction="row">
              <a href={`/uploads/files/pdf/expertise_lists/expertise_list_${id}.pdf`} target="_blank" rel="noreferrer">
                Экспертный лист 1 (просмотреть и скачать)
              </a>
            </GridItem>
          </TextLink>
        </GridItem>

        {!isPovs && (
          <>
            <GridItem align="center" justify="center" gap="15px" direction="row">
              <Radio.Group
                onChange={({ target: { value } }: RadioChangeEvent) =>
                  value === 'confirm' ? setConfirmState(true) : setConfirmState(false)
                }
                value={confirmState ? 'confirm' : 'cancel'}
                options={radioOptions}
              />
            </GridItem>
            {!confirmState && (
              <GridItem padding="0" justify="flex-start" align="flex-start" gap="5px">
                <div className="text">Комментарий:</div>
                <TextArea value={commentState} onChange={(e) => setComment(e.target.value)} />
              </GridItem>
            )}
            <GridItem justify="center" align="center" gap="35px" direction="row">
              <CustomButton onClick={() => (confirmState ? acceptExpertiseList() : rejectExpertiseList())}>
                Сохранить
              </CustomButton>
              <CustomButton onClick={() => setOpen(false)} lined>
                Отменить
              </CustomButton>
            </GridItem>
          </>
        )}
        {expertise_list?.expertise_list?.status.code === 'refactoring' && (
          <GridItem justify="flex-start" align="flex-start" padding="0" direction="row">
            <div style={{ padding: 0, color: '#606D7C' }} className="text">
              Причина отклонения: {expertise_list?.expertise_list?.fo_reject_comment || ' - '}
            </div>
          </GridItem>
        )}
        {isRejected && (
          <GridItem justify="center" align="center" gap="35px" direction="row">
            <CustomButton
              width="300px"
              onClick={() =>
                navigate(
                  isExpert
                    ? `${routerPath.editExpertExpertise}${expertise_list?.id}`
                    : `${routerPath.povsEditEl}${expertise_list?.id}`,
                )
              }
            >
              Редактировать
            </CustomButton>
            <CustomButton onClick={() => setOpen(false)} lined>
              Отменить
            </CustomButton>
          </GridItem>
        )}
      </GridItem>
    </CustomModal>
  );
};
